"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigApi = ConfigApi;
exports.getConfigApi = getConfigApi;
exports.listBillStatsPaged = listBillStatsPaged;
var _request = _interopRequireDefault(require("@/utils/request"));
// 结算配置
function ConfigApi(data) {
  return (0, _request.default)({
    url: '/portal/system/daily/settle/config',
    method: 'post',
    data: data
  });
}

// 查询结算配置
function getConfigApi(params) {
  return (0, _request.default)({
    url: '/portal/system/daily/settle/getConfig',
    method: 'get',
    params: params
  });
}

// 提现列表
function listBillStatsPaged(params) {
  return (0, _request.default)({
    url: '/portal/system/daily/settle/listBillStatsPaged',
    method: 'get',
    params: params
  });
}